import WatcherEntry from "./WatcherEntry";

export default WatcherEntry;
